import { WarningOutlined } from '@ant-design/icons';
import { Modal, ModalProps, Typography } from 'antd';
import { Trans, useTranslation } from 'react-i18next';

interface ConfirmHireCandidateModalProps extends ModalProps {
  remainingPositions: number;
  jobPostingName: string;
  candidateName: string;
  onSuccess?: () => void | Promise<unknown>;
}

const ConfirmHireCandidateModal = ({
  remainingPositions,
  jobPostingName,
  candidateName,
  ...props
}: ConfirmHireCandidateModalProps) => {
  const { t } = useTranslation();

  return (
    <Modal
      okButtonProps={{
        htmlType: 'submit',
      }}
      okText={remainingPositions < 1 ? t('Ok') : t('Contratar e concluir vaga')}
      title={
        remainingPositions < 1 ? (
          <Typography.Text strong>
            <WarningOutlined /> <Trans>Atenção! Esta ação não poderá ser realizada</Trans>
          </Typography.Text>
        ) : (
          <Typography.Text strong>
            <WarningOutlined /> <Trans>Atenção! Esta vaga será concluída automaticamente</Trans>
          </Typography.Text>
        )
      }
      {...props}
    >
      {remainingPositions < 1 ? (
        <Typography.Paragraph>
          <Trans>Esta vaga possui</Trans> {remainingPositions}{' '}
          <Trans>
            posições restantes e a quantidade de candidatos selecionados irá ultrapassar o limite de
            contratações permitidas para a vaga. Revisite os candidatos selecionados ou a quantidade
            de posições da vaga.
          </Trans>
        </Typography.Paragraph>
      ) : (
        <>
          <Typography.Paragraph>
            <Trans>
              Ao realizar esta movimentação, você preencherá todas as posições e esta vaga será
              concluída automaticamente.
            </Trans>
          </Typography.Paragraph>
          <Typography.Paragraph>
            <Trans>Essa ação</Trans>{' '}
            <Typography.Text strong>
              <Trans>não poderá ser desfeita</Trans>
            </Typography.Text>
            <Trans>, tem certeza que deseja contratar o(a) candidato(a)</Trans>{' '}
            <Typography.Text strong>{candidateName}</Typography.Text>{' '}
            <Trans>e concluir a vaga</Trans> {jobPostingName}?
          </Typography.Paragraph>
        </>
      )}
    </Modal>
  );
};

export default ConfirmHireCandidateModal;
